import { useState } from 'react';
import LeadFormStep1 from './LeadFormStep1';
import LeadFormStep2 from './LeadFormStep2';
import LeadFormStep3 from './LeadFormStep3';

const LeadFormMultiStep = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    business_name: '',
    email: '',
    phone: '',
    lead_id: '',
    verification_id: ''
  });
  
  const handleStep1Complete = (data) => {
    setFormData(prev => ({ ...prev, ...data }));
    setCurrentStep(2);
  };
  
  const handleStep2Complete = (leadId) => {
    setFormData(prev => ({ ...prev, lead_id: leadId }));
    setCurrentStep(3);
  };
  
  const handleStep3Complete = (result) => {
    console.log('Form completed! Result:', result);
    // Form stays on success screen (handled by LeadFormStep3 component)
  };
  
  return (
    <>
      {currentStep === 1 && (
        <LeadFormStep1 onComplete={handleStep1Complete} />
      )}
      
      {currentStep === 2 && (
        <LeadFormStep2
          email={formData.email}
          firstName={formData.first_name}
          verificationId={formData.verification_id}
          onVerified={handleStep2Complete}
        />
      )}
      
      {currentStep === 3 && (
        <LeadFormStep3
          leadId={formData.lead_id}
          firstName={formData.first_name}
          onComplete={handleStep3Complete}
        />
      )}
    </>
  );
};

export default LeadFormMultiStep;
